import React from 'react';
import { Mail, Instagram, Youtube, Music, ShoppingBag } from 'lucide-react';

const Footer = () => {
  return (
    <>
      {/* Contact & Social Media Banner */}
      <section className="py-12 px-4 bg-gradient-to-r from-green-50 via-white to-red-50 border-t border-gray-200">
        <div className="max-w-4xl mx-auto text-center">
          {/* Connect Heading */}
          <div className="mb-8">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 font-heading mb-2">
              Connect with Jamilah
            </h3>
          </div>
          
          {/* Social Media Links */}
          <div className="flex justify-center items-center space-x-4 mb-6">
            {/* Email */}
            <a 
              href="mailto:speakalgerian.contact@gmail.com"
              className="flex flex-col items-center space-y-2 text-red-400 hover:text-red-600 transition-colors duration-200 group"
            >
              <div className="w-12 h-12 bg-white rounded-full shadow-md flex items-center justify-center group-hover:shadow-lg transition-shadow duration-200">
                <Mail className="w-6 h-6" />
              </div>
              <span className="text-sm font-medium">Email</span>
            </a>

            {/* Instagram */}
            <a 
              href="https://instagram.com/speakalgerian"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center space-y-2 text-red-400 hover:text-red-600 transition-colors duration-200 group"
            >
              <div className="w-12 h-12 bg-white rounded-full shadow-md flex items-center justify-center group-hover:shadow-lg transition-shadow duration-200">
                <Instagram className="w-6 h-6" />
              </div>
              <span className="text-sm font-medium">Instagram</span>
            </a>

            {/* TikTok */}
            <a 
              href="https://tiktok.com/@speakalgerian"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center space-y-2 text-red-400 hover:text-red-600 transition-colors duration-200 group"
            >
              <div className="w-12 h-12 bg-white rounded-full shadow-md flex items-center justify-center group-hover:shadow-lg transition-shadow duration-200">
                <Music className="w-6 h-6" />
              </div>
              <span className="text-sm font-medium">TikTok</span>
            </a>

            {/* YouTube */}
            <a 
              href="https://youtube.com/@speakalgerian"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center space-y-2 text-red-400 hover:text-red-600 transition-colors duration-200 group"
            >
              <div className="w-12 h-12 bg-white rounded-full shadow-md flex items-center justify-center group-hover:shadow-lg transition-shadow duration-200">
                <Youtube className="w-6 h-6" />
              </div>
              <span className="text-sm font-medium">YouTube</span>
            </a>

            {/* Stan Store */}
            <a 
              href="https://stan.store/speakalgerian"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center space-y-2 text-red-400 hover:text-red-600 transition-colors duration-200 group"
            >
              <div className="w-12 h-12 bg-white rounded-full shadow-md flex items-center justify-center group-hover:shadow-lg transition-shadow duration-200">
                <ShoppingBag className="w-6 h-6" />
              </div>
              <span className="text-sm font-medium">Shop</span>
            </a>
          </div>

          {/* Contact Message */}
          <div className="text-center">
            <p className="text-sm text-gray-600 max-w-2xl mx-auto">
              Questions about Algerian Derja? Want to suggest new words or features? 
              <br />
              Follow me on social media or send an email - I'd love to hear from you! 💚
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-4 bg-white border-t border-gray-200">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-600">
            <p>&copy; 2024 Speak Algerian. All rights reserved.</p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="/terms" className="hover:text-green-600 transition-colors">Terms of Service</a>
              <a href="/privacy" className="hover:text-green-600 transition-colors">Privacy Policy</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
